(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kami-product-shop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('.kami-quantity select')) return;
  const link = event.target.closest('.kami-purchase').querySelector('[data-kami-buy]');
  if (!link) return;
  const url = new URL(link.href);
  url.pathname = url.pathname.replace(/:\d+$/, ':' + event.target.value);
  link.href = url.toString();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
